import React from "react";
import BookCover from "./BookCover";
import useAppTranslation from "../../hooks/useAppTranslation";

const BookCoverSlideList = ({
  books,
  isAudioOnly,
  categories,
  onStorySelect,
  isSelectMode,
  selectedBookId,
  sectionRefs,
}) => {
  const { t } = useAppTranslation("pages/myStorybook");
  // 카테고리별 필터링 함수
  const filterByStyle = (styleType) => {
    return books.filter((book) => {
      // 오디오북 필터링
      if (isAudioOnly && !book.has_audiobook) return false;

      if (styleType === "all") return true;
      if (styleType === "novel")
        return book.style === "그림 소설" || book.style === "graphic_novel";
      if (styleType === "picture")
        return (
          book.style === "그림 동화" ||
          book.style === "picture_book" ||
          book.style === null
        );
      return false;
    });
  };

  const categorySections = categories.map((category) => ({
    ...category,
    data: filterByStyle(category.key),
  }));

  return (
    <div className="book-slide-list-container">
      {categorySections.map((cat) => (
        <section
          key={cat.key}
          className="category-section"
          ref={sectionRefs[cat.key]}
          data-category={cat.key}
        >
          <h4 className="category-title">{cat.label}</h4>
          <ul className="box-conts vertical-list">
            {cat.data.length > 0 ? (
              cat.data.map((book, index) => (
                <BookCover
                  key={book.book_id || index}
                  {...book}
                  index={index}
                  bookId={book.book_id}
                  selectedBookId={selectedBookId}
                  isSelectMode={isSelectMode}
                  onClick={() => onStorySelect(book)}
                  hasAudio={book.has_audiobook}
                />
              ))
            ) : (
              <li className="no-data">{t("empty")}</li>
            )}
          </ul>
        </section>
      ))}
    </div>
  );
};

export default BookCoverSlideList;
